import request from '../utils/request'
const userinfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const headers = {
  //7026060
  'User-ID': userinfo && userinfo.access ? userinfo.access.userId : '',
  'Access-Token': userinfo && userinfo.access ? userinfo.access.accessToken  : '',
  'APP-Name': 'jianpin_web_editor'
}
const requestBase = {
  // post 请求
  post(url, data) {
    return new Promise((resolve) => {
      let userinfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      request({
        url: 'pc_web/' + url,
        method: 'post',
        data,
        headers:  {
          //7026060
          'User-ID': userinfo && userinfo.access ? userinfo.access.userId : '',
          'Access-Token': userinfo && userinfo.access ? userinfo.access.accessToken  : '',
          'APP-Name': 'jianpin_web_editor'
        }
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        const errorParam = {
          code: err.code,
          message: err.message,
        }
        // reject(err);
        resolve(errorParam);
      })
    })
  },
  // get 请求
  get(url, data) {
    url = url + '?' + data.toString();
    
    return new Promise(resolve => {
      let userinfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      let headers = {
        //7026060
        'User-ID': userinfo && userinfo.access ? userinfo.access.userId : '',
        'Access-Token': userinfo && userinfo.access ? userinfo.access.accessToken  : '',
        'APP-Name': 'jianpin_web_editor'
      }
      request({
        url,
        headers
      }).then((error, response, body) => {
        if (error) {
          resolve([error, undefined]);
        } else {
          const data = JSON.parse(body)
          resolve([null, data]);
        }
      })
    })
  }
}

export {headers}
export default requestBase;